import { render, staticRenderFns } from "./formatSetting.vue?vue&type=template&id=78904143&scoped=true&"
import script from "./formatSetting.vue?vue&type=script&lang=js&"
export * from "./formatSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78904143",
  null
  
)

export default component.exports